import { useEffect, useState } from "react";
import API from "../api/api";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";

export default function GuideAvailability() {
  const [guides, setGuides] = useState([]);
  const [selectedGuide, setSelectedGuide] = useState("");
  const [availability, setAvailability] = useState([]);
  const [availableGuides, setAvailableGuides] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [viewGuide, setViewGuide] = useState(null);
  const [guideSlots, setGuideSlots] = useState([]);


  useEffect(() => {
    API.get("/admin/guides")
      .then((res) => setGuides(Array.isArray(res.data) ? res.data : []))
      .catch((err) => {
        console.error(err);
        setGuides([]);
      });
  }, []);

  const loadGuideAvailability = async (guideId) => {
    if (!guideId) return setAvailability([]);

    try {
      const res = await API.get(`/admin/guides/availability/${guideId}`);
      setAvailability(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("loadGuideAvailability error:", err);
      setAvailability([]);
    }
  };

  const openGuideView = async (guide) => {

  setViewGuide(guide);

  try {

    const res = await API.get(
      `/admin/guides/availability/${guide.id}`
    );


    const slots = res.data.filter((slot)=>{

      return slot.start_datetime.startsWith(selectedDate);

    });


    setGuideSlots(slots);


  } catch(err){

    console.error(
      "Failed loading guide slots",
      err
    );

    setGuideSlots([]);

  }

};

  const handleDateClick = async (info) => {
  const date = info.dateStr.split("T")[0];

 

  setSelectedDate(date);

  try {
    const res = await API.get(
      "/admin/guides/availability/search",
      {
        params: { date }
      }
    );

   

    setAvailableGuides(res.data || []);

  } catch (err) {
    console.error("🔴 SEARCH FAILED:", err);

    if (err.response) {
      console.error("STATUS:", err.response.status);
      console.error("DATA:", err.response.data);
    }

    setAvailableGuides([]);
  }
};

  return (
    <div style={page}>

      <h1 style={title}>
        📅 Guide Availability Dashboard
      </h1>


      <div style={grid}>


        {/* LEFT PANEL */}
        <div style={card}>

          <h3 style={sectionTitle}>
            👨‍💼 Select Guide
          </h3>


          <select
            value={selectedGuide}
            onChange={(e) => {
              const id = e.target.value;
              setSelectedGuide(id);
              loadGuideAvailability(id);
            }}
            style={select}
          >

            <option value="">
              Select a guide
            </option>

            {guides.map((g) => (
              <option key={g.id} value={g.id}>
                {g.first_name} {g.last_name}
              </option>
            ))}

          </select>


          {!selectedGuide ? (

            <p style={hint}>
              Select a guide to view availability
            </p>

          ) : (

            <div style={{marginTop:20}}>

              <div style={statusBox}>
                🟢 Green slots show availability
              </div>


              <div style={count}>
                {availability.length} available dates loaded
              </div>

            </div>

          )}

        </div>



        {/* CALENDAR */}
        <div style={calendarCard}>

          <h3 style={sectionTitle}>
            🗓 Weekly Schedule
          </h3>


          <FullCalendar

            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin
            ]}

            initialView="timeGridWeek"

            dateClick={handleDateClick}

            height={700}

            allDaySlot={false}

            nowIndicator={true}

            expandRows={true}

            slotMinTime="07:00:00"

            slotMaxTime="20:00:00"

            slotDuration="00:30:00"

            headerToolbar={{
              left:"prev,next today",
              center:"title",
              right:""
            }}


            events={
              availability.map((a)=>({

                id:a.id,

                title:a.title || "Available",

                start:a.start_datetime,

                end:a.end_datetime,

                backgroundColor:"#22c55e",

                borderColor:"#22c55e",

                textColor:"#fff"

              }))
            }

          />

        </div>




        {/* RIGHT PANEL */}
        <div style={card}>


          <h3 style={sectionTitle}>
            ✅ Available Guides
          </h3>


          {selectedDate ? (

            <div style={dateBadge}>
              📅 {selectedDate}
            </div>

          ) : (

            <p style={hint}>
              Click a date to view available guides
            </p>

          )}



          {availableGuides.length === 0 ? (

            <p style={hint}>
              No guides available
            </p>

          ) : (

            availableGuides.map((g)=>(

              <div
                key={g.id}
                style={guideRow}
              >

                <div>

                  <b>
                    {g.first_name} {g.last_name}
                  </b>


                  <div style={email}>
                    {g.email}
                  </div>

                </div>


                <button
                  style={btnSmall}
                  onClick={() => openGuideView(g)}
                >
                  View
                </button>


              </div>

                    ))

                  )}


                </div>


              </div>

       {viewGuide && (

<div style={modalOverlay}>

<div style={modal}>


<h2>
👤 Guide Details
</h2>


<h3>
{viewGuide.first_name} {viewGuide.last_name}
</h3>


<p>
📧 {viewGuide.email}
</p>


<h4>
Available slots on {selectedDate}
</h4>


{
guideSlots.length === 0 ? (

<p>
No available slots
</p>

) : (

guideSlots.map((slot)=>(

<div
key={slot.id}
style={slotCard}
>

🟢

{
new Date(slot.start_datetime)
.toLocaleTimeString([],{
hour:"2-digit",
minute:"2-digit"
})
}

&nbsp; -

&nbsp;

{
new Date(slot.end_datetime)
.toLocaleTimeString([],{
hour:"2-digit",
minute:"2-digit"
})
}


</div>

))

)
}



<div
  style={{
    display:"flex",
    justifyContent:"flex-end",
    marginTop:20
  }}
>

<button
style={closeBtn}
onClick={()=>{
setViewGuide(null);
setGuideSlots([]);
}}
>
Close
</button>


</div>


</div>

</div>

)}

    </div>
  );
}
/* ================= MODERN DASHBOARD STYLES ================= */

const page = {
  padding: 30,
  minHeight: "100vh",
  background:
    "linear-gradient(135deg,#C75028 0%,#D86C37 50%,#E68A45 100%)",
};


const title = {
  color: "white",
  fontSize: 34,
  fontWeight: 800,
  marginBottom: 28,
  letterSpacing: ".5px",
};



const grid = {
  display: "grid",
  gridTemplateColumns: "320px 1.8fr 320px",
  gap: 24,
  alignItems: "start",
};



const card = {
  background: "white",
  borderRadius: 22,
  padding: 24,
  boxShadow:
    "0 15px 35px rgba(0,0,0,.12)",
};



const calendarCard = {
  background: "white",
  borderRadius: 22,
  padding: 25,
  boxShadow:
    "0 15px 35px rgba(0,0,0,.12)",
  minHeight: 760,
};



const sectionTitle = {
  fontSize: 20,
  fontWeight: 750,
  marginBottom: 18,
  color:"#1f2937",
};



const select = {
  width:"100%",
  padding:"13px 15px",
  borderRadius:14,
  border:"1px solid #ddd",
  fontSize:15,
  outline:"none",
  background:"#fff",
};



const hint = {
  marginTop:18,
  fontSize:14,
  color:"#6b7280",
};



const statusBox = {
  padding:"12px 14px",
  borderRadius:12,
  background:"#ecfdf5",
  color:"#15803d",
  fontSize:14,
  fontWeight:600,
};



const count = {
  marginTop:15,
  fontSize:13,
  color:"#6b7280",
};



const dateBadge = {
  background:"#fff7ed",
  color:"#c2410c",
  padding:"10px 14px",
  borderRadius:12,
  fontWeight:600,
  marginBottom:15,
};



const guideRow = {
  display:"flex",
  justifyContent:"space-between",
  alignItems:"center",
  padding:15,
  marginBottom:12,
  background:"#fafafa",
  borderRadius:14,
  border:"1px solid #eee",
  boxShadow:
    "0 3px 10px rgba(0,0,0,.04)",
};



const email = {
  marginTop:5,
  fontSize:13,
  color:"#6b7280",
};



const btnSmall = {
  padding:"9px 17px",
  background:"#F97316",
  color:"white",
  border:"none",
  borderRadius:10,
  cursor:"pointer",
  fontWeight:700,
};

const modalOverlay = {
  position:"fixed",
  inset:0,
  background:"rgba(0,0,0,.45)",
  display:"flex",
  justifyContent:"center",
  alignItems:"center",
  zIndex:1000,
};


const modal = {
  width:400,
  background:"white",
  borderRadius:20,
  padding:25,
  boxShadow:
    "0 20px 50px rgba(0,0,0,.25)",
};


const modalInfo = {
  marginTop:15,
  background:"#fafafa",
  borderRadius:14,
  padding:15,
};


const closeBtn = {
  padding:"9px 17px",
  background:"#e5e7eb",
  color:"#111",
  border:"none",
  borderRadius:10,
  cursor:"pointer",
  fontWeight:700,
};

const slotCard = {
  padding:"12px 15px",
  marginTop:10,
  background:"#ecfdf5",
  borderRadius:12,
  color:"#15803d",
  fontWeight:700,
  border:"1px solid #bbf7d0",
};



